module.exports = __webpack_public_path__ + "static/img/020.a140c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/020.png
// module id = 2Ky3
// module chunks = 1